import { MAIN_NAV_BAR_HEIGHT, SPACING } from 'd2/constants'

export const scrollTo = ({
  xPosition,
  yPosition,
}: {
  xPosition: number,
  yPosition: number
}) => {
  if (typeof window === 'undefined') return

  try {
    window.scrollTo({
      behavior: 'smooth',
      left: xPosition,
      top: yPosition,
    })
  } catch {
    window.scrollTo(xPosition, yPosition)
  }
}

export const scrollToElement = (
  element: Element,
  {
    x = false, // by default don't scroll to x position, because usually users only scroll vertically.
    y = true, // by default scroll to y position.
  }: {
    x?: boolean,
    y?: boolean,
  } = {}): void => {
  const { left, top } = element.getBoundingClientRect()

  scrollTo({
    xPosition: x ? left + window.scrollX : 0,
    // Account for the main nav bar height, so that the element is not hidden by the main nav bar.
    yPosition: y ? top + window.scrollY - MAIN_NAV_BAR_HEIGHT - SPACING : 0,
  })
}

export const scrollToTop = (): void => {
  scrollTo({
    xPosition: 0,
    yPosition: 0,
  })
}
